import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'gatewee-name-document-tableitem-v2',
  templateUrl: './name-document-tableitem-v2.component.html',
  styleUrls: ['./name-document-tableitem-v2.component.css'],
  standalone: false,
})
export class NameDocumentTableitemV2Component {
  constructor(private readonly router: Router) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() row: any;

  @Input() photo = true;

  @Input() nameLength = 25;

  @Input() smallFont = false;

  @Input() type?: string;

  @Input() email?: string;

  @Input() size: 's' | 'm' | 'l' = 'm';

  onClick() {
    switch (this.type) {
      case 'client':
        return this.router.navigate(['/panel/clients/details', this.row.id]);
      case 'recipient':
        return this.router.navigate(['/panel/recipients/view', this.row.id]);
      default:
        return;
    }
  }

  get displayName(): string {
    if (!this.row?.name) return '';
    const name = this.row.name;
    if (name.length <= this.nameLength) return name;
    return name.substring(0, this.nameLength) + '...';
  }
}
